export enum ConsentDetailsEvents {
  ChangeAgreement = 'changeAgreement',
}

export interface ChangeAgreementEventData {
  id: string;
  value: boolean;
}
